import { render, staticRenderFns } from "./CustomizeMetalI.vue?vue&type=template&id=773c031c&scoped=true"
import script from "./CustomizeMetalI.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalI.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalI.vue?vue&type=style&index=0&id=773c031c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c031c",
  null
  
)

export default component.exports